var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EDE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H28",
    stroke: "#8563DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23H24",
    stroke: "#8563DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33.5V33C25 30.1716 25 28.7574 25.8787 27.8787C26.7574 27 28.1716 27 31 27H31.5M32 25.3431V22C32 18.2288 32 16.3432 30.8284 15.1716C29.6569 14 27.7712 14 24 14C20.2288 14 18.3431 14 17.1716 15.1716C16 16.3431 16 18.2288 16 22V26.5442C16 29.7892 16 31.4117 16.8861 32.5107C17.0651 32.7327 17.2673 32.9349 17.4893 33.1139C18.5883 34 20.2108 34 23.4558 34C24.1614 34 24.5141 34 24.8372 33.886C24.9044 33.8623 24.9702 33.835 25.0345 33.8043C25.3436 33.6564 25.593 33.407 26.0919 32.9081L30.8284 28.1716C31.4065 27.5935 31.6955 27.3045 31.8478 26.9369C32 26.5694 32 26.1606 32 25.3431Z",
    stroke: "#8563DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.dbb697d72c0e9f8773d7dabeabc2e06d.svg";
export { ForwardRef as ReactComponent };